import {
  z,
  uploadedFileBaseSchema,
  uploadStatusSchema,
  createUploadedFilesSchema,
  createFileUploadValidator,
} from '@tasama/utils';
import { i18n } from '@tasama/i18n';

// NDA allows exactly 1 file; the File object for server upload is stored
// on the store's extended type only (not in the Zod schema).
export const ndaUploadedFileSchema = uploadedFileBaseSchema;
export const NDAUploadStatusEnum = uploadStatusSchema;

export const ndaUploadSchema = z.object({
  uploadedFiles: createUploadedFilesSchema({
    maxBytes: 5 * 1024 * 1024,
    allowedExts: ['pdf', 'png', 'jpg', 'jpeg'],
    minFiles: 1,
    messages: {
      required: i18n.t('nda.validation.required', { ns: 'portal' }),
      tooLarge: i18n.t('nda.validation.tooLarge', { ns: 'portal' }),
      invalidType: i18n.t('nda.validation.invalidType', { ns: 'portal' }),
    },
  }),
});

export type NDAUploadFormData = z.infer<typeof ndaUploadSchema>;
export type NDAUploadedFile = z.infer<typeof ndaUploadedFileSchema>;

export const ndaUploadDefaultValues: NDAUploadFormData = {
  uploadedFiles: [],
};

export const validateNDAUploadForm = createFileUploadValidator(ndaUploadSchema);
